<template>
  <label tabindex="0" role="radio" class="tw-radio-container tw-label-new" :class="mainClass" :title="labelTitle" @mouseup="$emit('labelClick')"  @keyup="keyup" :aria-checked="model === value">
    <input v-model="model" type="radio" :value="value" class="hidden" :disabled="disabled" :required="required" @click="onClick">
    <div role="radio" class="tw-radio-checked" :class="{'tw-radio-checked-disabled': disabled, 'tw-radio-checked-large': size ==='large'}" v-if="model === value"/>
    <div role="radio" class="tw-radio-empty" :class="{'tw-radio-empty-disabled': disabled, 'tw-radio-empty-large': size ==='large', 'tw-radio-empty-error': error}" v-else/>
    <span v-if="label" :class="getClass" >{{label}}</span>
    <slot />
  </label>
</template>

<script>
export default {
  props:{
    modelValue: { type: [String, Boolean] },
    value: { type: [String, Boolean] },
    label: { type: String },
    disabled:{default: false},
    required:{default: false},
    size:{ type: String, default: 'normal' },
    color:{ type: String, default: 'blue' },
    labelClasses: {type: String, default: undefined},
    mainClass: {type: String, default: ''},
    labelTitle: {type: String, default: undefined},
    error: {type: Boolean, default: false},
    allowDeselect:{type: Boolean, default: false}
  },
  computed: {
    model:{
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
        this.$emit('customClick', value)
      }
    },
    getClass(){
      return this.labelClasses ? this.labelClasses : 'tw-text-sm h-5'
    },
  },
  methods: {
    onClick(e){
      if (this.allowDeselect && this.value === this.modelValue && e.target.checked){
        this.model=undefined
      }
    },
    keyup(e){
      if(e.keyCode === 13){
        if(this.model === this.value){
          this.model=undefined
        }else {
          this.model = this.value
        }
      }
    }
  }
};
</script>
